<template>
  <el-drawer
    title="合同优惠"
    :visible.sync="drawer"
    destroy-on-close
    :modal-append-to-body="false"
    append-to-body
    :wrapperClosable="false"
    :custom-class="sidebarIsOpen ? 'width210' : 'width54'"
  >
    <el-card class="first">
      <el-form ref="Form" :inline="true" :model="queryData" size="small">
        <Grid>
          <GridItem>
            <el-form-item label="项目名称：" prop="communityId">
              <el-select v-model="queryData.communityId" filterable clearable placeholder="选择项目">
                <el-option v-for="item in searchCommunities" :key="item.communityId" :label="item.communityName" :value="item.communityId" />
              </el-select>
            </el-form-item>
          </GridItem>
          <GridItem>
            <el-form-item label="收费科目：" prop="itemId">
              <el-select v-model="queryData.itemId" filterable clearable placeholder="选择收费科目">
                <el-option v-for="item in chargeItemListArr" :key="item.chargeItemId" :label="item.chargeItemName" :value="item.chargeItemId" />
              </el-select>
            </el-form-item>
          </GridItem>
          <GridItem>
            <el-form-item label="审批状态：" prop="applyState">
              <el-select v-model="queryData.applyState" filterable clearable placeholder="选择审批状态">
                <el-option v-for="item in applyStateArr" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </GridItem>
          <GridItem className="grid-item-search">
            <el-form-item>
              <ELButton size="small" describe="查询" :myFunction="queryForm" type="primary" />
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-form-item>
          </GridItem>
        </Grid>
      </el-form>
    </el-card>
    <el-card>
      <el-table ref="multipleTable" row-key="id" :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
        <el-table-column label="项目名称" align="center">
          <template slot-scope="scope">{{ getCommunityName(scope.row.communityId) }}</template>
        </el-table-column>
        <el-table-column label="资产编号" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.buildingRoomCode && scope.row.itemTargetName === '房屋'">房屋/{{ scope.row.buildingRoomCode }}</span>
            <span v-if="scope.row.itemTargetName === '车位'">
              车位/
              <span v-if="scope.row.parkingName">{{ scope.row.parkingName }}</span>
              <span v-if="scope.row.parkingSpaceName">{{ scope.row.parkingSpaceName }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="收费科目" align="center">
          <template slot-scope="scope">{{ scope.row.itemName || '-' }}</template>
        </el-table-column>
        <el-table-column label="应收金额" align="center" width="100">
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.orderAmount) }}</template>
        </el-table-column>
        <el-table-column label="优惠金额" align="center" width="100">
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.preferentialAmount) }}</template>
        </el-table-column>
        <el-table-column label="审批状态" align="center">
          <template slot-scope="scope">
            {{ dictType('applyStateArr', scope.row.applyState) }}
          </template>
        </el-table-column>
        <el-table-column label="当前审批节点" align="center">
          <template slot-scope="scope">
            {{ scope.row.currentNode || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="申请日期" align="center" width="150">
          <template slot-scope="scope">
            {{ cutTime(scope.row.createTime, ' ') }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" fixed="right" align="center" width="180">
          <template slot-scope="scope">
            <el-link type="primary" @click="preview(scope.row)">详情</el-link>
            <el-link v-if="scope.row.applyState === 2" type="primary" @click="revoke(scope.row)">撤销</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, prev, pager, next, jumper,sizes"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="[10, 50, 100]"
        :total="total"
        @size-change="currentChange"
        @current-change="currentChange"
      />
    </el-card>
    <Revoke ref="Revoke" />
    <Preview ref="Preview" />
  </el-drawer>
</template>

<script>
import Revoke from './components/Revoke.vue'
import Preview from './components/Preview.vue'
import { chargeItemDropList } from '@/api/dropList'
import { flowApplyCommercePreInfo, flowCommerceOrderPreferentialPage, flowCommerceOrderPreferentialCount } from '@/api/leaseManagement'
export default {
  components: {
    Revoke,
    Preview,
  },
  provide() {
    return {
      indexThis: this,
    }
  },
  data() {
    return {
      drawer: false,
      tableData: [],
      queryData: {
        applyState: '',
        communityId: '',
        itemId: '',
      },
      applyStateArr: [
        // 审批状态
        {
          value: 2,
          label: '审批中',
        },
        {
          value: 3,
          label: '驳回',
        },
        {
          value: 4,
          label: '审批通过',
        },

        { value: 12, label: '已撤销' },
      ],

      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      queryData: {
        organizationId: '',
      },
      total: 0,
      chargeItemListArr: [],
    }
  },
  watch: {
    drawer(val) {
      if (val) {
        this.init()
        this.getChargeItemList()
      }
    },
  },
  methods: {
    init() {
      this.flowCommerceOrderPreferentialPage()
      this.flowCommerceOrderPreferentialCount()
    },
    async flowCommerceOrderPreferentialPage() {
      const { data: res } = await flowCommerceOrderPreferentialPage({ ...this.page, ...this.queryData, applyStaffName: this.USER_NAME })
      this.tableData = res || []
    },

    async flowCommerceOrderPreferentialCount() {
      const { data: total } = await flowCommerceOrderPreferentialCount({ ...this.page, ...this.queryData, applyStaffName: this.USER_NAME })
      this.total = parseInt(total || 0)
    },

    // 获取收费科目
    async getChargeItemList() {
      const { data } = await chargeItemDropList()
      this.chargeItemListArr = data || []
    },

    queryForm() {
      this.page.pageNo = 1
      this.queryData = {
        ...this.queryData,
      }
      this.init()
    },
    resetForm() {
      this.$refs.Form.resetFields()
      this.queryData = { ...this.queryData }
      this.page.pageNo = 1
      this.init()
    },
    preview(value) {
      this.$refs.Preview.getDetail(value.applyOverviewId)
      this.$refs.Preview.drawer = true
    },

    // 撤销
    revoke(value) {
      this.$refs.Revoke.addForm.flowApplyOverviewId = value.applyOverviewId
      this.$refs.Revoke.drawer = true
    },
    currentChange() {
      this.init()
    },
  },
}
</script>

<style lang="less" scoped></style>
